// extracted by mini-css-extract-plugin
module.exports = {"container":"CalendarNewPage_container__1T2xX","side_panel":"CalendarNewPage_side_panel__Ucymu","main_panel":"CalendarNewPage_main_panel__2UCoM"};